// One readable sentence out of any API failure. FastAPI returns `detail` as a
// string for our own errors but as a LIST of objects for 422 validation errors —
// handing that straight to a toast renders nothing, which hides the failure.

export function errorMessage(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const first = detail.find((d) => typeof d?.msg === "string");
    if (first) return fallback;
  }
  if (!err?.response) return "No connection. Please check your internet and try again.";
  return fallback;
}

/** Status code / short reason for analytics — never any personal data. */
export function errorReason(err) {
  const status = err?.response?.status;
  if (!status) return "network";
  return String(status);
}
